import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem, TextField } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../../redux/slice/user";
import api from "../../../API";
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import VieCreateListPage from "./VieCreateListPage";
import { String } from "lodash";

const initail_img_cnt: any = {
  img_2_cnt:  0,
  img_1_cnt:  0,
  img_0_cnt:  0
}


const VieWorkerCreatePage = (props:any) => {

  const dispatch = useDispatch();

  const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)
  
  const [task, setTask] = useState("01");

  const [idx, setIdx] = useState("");

  const [sub_code, setSub_code] = useState("");

  const [img_name, setImg_name] = useState("");

  const [workList, setWorkList] = useState([]);

  const [img_cnt, setImg_cnt] = useState<any>("모두");

  const [img_cnt_status, setImg_cnt_status] = useState<any>(initail_img_cnt);

  const [page, setPage] = useState(1);
  
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [backdrop, setBackdrop] = useState<boolean>(false)

  const vieWorkList = async (task:string,p?:string) => {
    let url = '/vie-create-workList'
    let p_img_cnt = ""
    // console.log('p',p)
    // console.log('img_cnt',img_cnt)

    if(p) {p_img_cnt = p}
    else {p_img_cnt = img_cnt}

    setBackdrop(true)
    api.get(url,{params:{email:email,page:page,worker:worker,task:task,idx:idx,sub_code:sub_code,img_name:img_name,img_cnt:p_img_cnt}})
    .then((res:any) => {
      if(res.data.datas.length > 0){
        setWorkList(res.data);
        setTotal_cnt(res.data.pagination.total_count)
        if(task=="10"){
          setImg_cnt_status(res.data.img_status)
        }
      }else{
        setWorkList(res.data);
        setTotal_cnt(0)
      }
      setBackdrop(false)
      })
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
  }

  const getAuth = async () => {
    if(!email){ nav('/') }
    api.get('/@me',{params:{email:email}})
    .then((resp:any) => {dispatch(setUserInfo(resp.data)); console.log('/@me',resp.data) })
    .catch((error:any) => {console.error('에러',error.response);})
  }

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  useEffect(() => {
    getAuth()
    vieWorkList(task)
  },[page,task])

  return (
    <Box>
      {backdrop && ( <SearchBackDrop/> )}
      {/* 상단 메뉴 */}
      <Box display="flex" sx={{padding:"4px 8px 8px 8px"}}>
        <Box display="flex">
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px",alignSelf: "center"}}>신규작업 목록 (<b style={{color:"#1976d2"}}>{total_cnt != 0 ? total_cnt:0}</b> 건)</Box>
          <Select id="task" value={task} onChange={(e)=> { setTask(e.target.value); vieWorkList(e.target.value);}} sx={{width:"150px",height: "30px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"01"}>01.CSQA</MenuItem>
            <MenuItem dense value={"02"}>02. HLSW</MenuItem>
            <MenuItem dense value={"03"}>03. MMLU</MenuItem>
            <MenuItem dense value={"04"}>04. TFQA</MenuItem>
            <MenuItem dense value={"05"}>05. COMG</MenuItem>
            <MenuItem dense value={"06"}>06. HHH</MenuItem>
            <MenuItem dense value={"07"}>07. WNGD</MenuItem>
            <MenuItem dense value={"08"}>08. DROP</MenuItem>
            <MenuItem dense value={"09"}>09. BOOLQ</MenuItem>
            <MenuItem dense value={"10"}>10. MMMU</MenuItem>
          </Select>
          {task == "10" && 
          <>
            <Box sx={{marginLeft:"16px", marginRight:"20px", fontWeight:700, letterSpacing:"-2px",alignSelf: "center"}}>IDX</Box>
            <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                      value={idx} onChange={(e) => {setIdx(e.target.value);}}
            // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
              InputProps={{
                style: {width: "80px", height:"30px", fontSize:"14px"},
                inputProps: { 
                  spellCheck: "false" // spellcheck를 false로 설정
                },
              }} 
            />

            <Box sx={{marginLeft:"16px", marginRight:"20px", fontWeight:700, letterSpacing:"-2px",alignSelf: "center"}}>ID</Box>
            <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                      value={sub_code} onChange={(e) => {setSub_code(e.target.value);}}
            // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
              InputProps={{
                style: {width: "200px", height:"30px", fontSize:"14px"},
                inputProps: { 
                  spellCheck: "false" // spellcheck를 false로 설정
                },
              }} 
            />
            <Box sx={{marginLeft:"16px", marginRight:"20px", fontWeight:700, letterSpacing:"-2px",alignSelf: "center"}}>이미지명</Box>
            <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                      value={img_name} onChange={(e) => {setImg_name(e.target.value);}}
            // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
              InputProps={{
                style: {width: "250px", height:"30px", fontSize:"14px"},
                inputProps: { 
                  spellCheck: "false" // spellcheck를 false로 설정
                },
              }} 
            />
            <Button variant="contained" size="small" sx={{fontWeight:700, margin:"4px 8px", marginLeft:"auto", backgroundColor:"#2381fd"}}
                onClick={() => {
                  setPage(1); vieWorkList('10');
                }}
              >
                적용
            </Button>
            <Box sx={{marginLeft:"16px", marginRight:"20px", fontWeight:700, letterSpacing:"-2px",alignSelf: "center"}}>이미지개수</Box>
            <Select id="img_cnt" value={img_cnt} onChange={(e)=> { setImg_cnt(e.target.value); vieWorkList("10",e.target.value);}} sx={{width:"150px",height: "30px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
              <MenuItem dense value={"모두"}>모두</MenuItem>
              <MenuItem dense value={"2"}>2개</MenuItem>
              <MenuItem dense value={"1"}>1개</MenuItem>
              <MenuItem dense value={"0"}>0개</MenuItem>
            </Select>
            <Box sx={{marginLeft: "8px", fontSize: "24px"}}>{"["}<b style={{color:"blue"}}>2개:{img_cnt_status.img_2_cnt} </b>, <b style={{color:"green"}}>1개:{img_cnt_status.img_1_cnt}</b>, <b style={{color:"red"}}>0개:{img_cnt_status.img_0_cnt}</b>{"]"}</Box>
          </>
        }
        </Box>
      </Box>
      {/* 상단 메뉴 */}

      {/* Task 단위 화면 */}
      <VieCreateListPage task={task} setPage={setPage} goPage={goPage} workList={workList} vieWorkList={vieWorkList}/>
      {/* Task 단위 화면 */}
    </Box>
  );
};

export default VieWorkerCreatePage;
